//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ParamsJsonSchemaView from './components/paramsJsonSchemaView.vue';
export default {
  components: {ParamsJsonSchemaView},
  data() {
    return {
      agentTool: {},
    };
  },
  async mounted() {
    this.getAgentTool();
  },
  methods: {
    async getAgentTool() {
      const { agent_tool: agentTool } = await this.$request({
        data: {
          id: this.$route.query.id,
          is_system: this.$route.query.is_system === true || this.$route.query.is_system === 'true',
        },
        url: this.$api.getAgentTool,
      });
      this.agentTool = agentTool;
    },
  },
};
